const activeTag = () => {
    const tag = document.querySelectorAll('.news-aside__tag'),
          blurBlock =document.querySelector('.news-aside__blur');

    if(tag) {
        tag.forEach(item =>{
            item.addEventListener('click', (e) => {
                e.preventDefault();
                item.classList.toggle('news-aside__tag_active');
            })
        })
    }
    const moreTags = document.querySelector('.news-aside__more');
    if(moreTags) {
        let executive = false;
        moreTags.addEventListener('click', () =>{
            if(!executive) {
                moreTags.previousElementSibling.style.maxHeight ='2000px';
                blurBlock.style.opacity = '0';
                blurBlock.style.visibility = 'hidden';

                moreTags.classList.add('rotate');
                moreTags.innerHTML = 'Hide';
                return executive = true
            } else {
                moreTags.previousElementSibling.style.maxHeight ='366px';
                blurBlock.style.opacity = '1';
                blurBlock.style.visibility = 'visible';
                moreTags.classList.remove('rotate');
                moreTags.innerHTML = 'View more';
                return executive = false
            }
            
        })
    }
}

export default activeTag;